import {LineupPlayerToDownloadStructure, AbstractOptimizedLineupsView} from './optimized-lineups-view';

export class YahooOptimizedLineupsView extends AbstractOptimizedLineupsView {
    protected getPlayerCellView(player: LineupPlayerToDownloadStructure): string {
        return `${player.id} - ${this.adjustPlayerName(player.name)}`;
    }
}
